import { Image } from "@warp/types/product"

const getLastSrcsetUrl = (srcset: { [key: string]: string }): string => {
  const sizes = Object.keys(srcset)
  const lastSize = sizes[sizes.length - 1]
  return srcset[lastSize]
}

const buildSrcsetString = (srcset: { [key: string]: string }): string => {
  return Object.entries(srcset)
    .map(([size, url]) => `${url} ${size}`)
    .join(", ")
}

const buildImageObjectFromUrl = (
  src: string,
  alt?: string
): Pick<Image, "srcset" | "alt" | "id" | "thumbnail"> => {
  return {
    id: 1,
    alt: alt || "",
    srcset: {
      "768w": src
    },
    thumbnail: {
      alt: alt || "",
      srcset: {
        "450w": src
      }
    }
  }
}

export { getLastSrcsetUrl, buildSrcsetString, buildImageObjectFromUrl }
